import classnames from 'classnames';
import { isXiaoLaChuXing } from '@/utils';
import loadingCar from './loading-car.png';
import xiaolaLoadingCar from './xiaola-loading-car.png';
import './hll-loading-icon.scss';

export interface HllLoadingIconProps {
  isXiaoLa?: boolean;
  size?: 'small' | 'middle' | 'large' | 'huge';
}

const HllLoadingIcon: React.FC<HllLoadingIconProps> = ({ size = 'middle' }) => {
  return (
    <div className={classnames('hll-loading-icon', `hll-loading-icon-${size}`)}>
      <div className="hll-loading-icon-circle" />
      <div className="hll-loading-icon-outter">
        <img
          src={isXiaoLaChuXing() ? xiaolaLoadingCar : loadingCar}
          className="hll-loading-icon-inner"
          alt=""
        />
      </div>
    </div>
  );
};

export default HllLoadingIcon;
